import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from './contexts/AuthContext';

// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import GreenInventory from './pages/GreenInventory';
import Roasting from './pages/Roasting';
import RoastedStockV2 from './pages/RoastedStockV2';
import Wastage from './pages/Wastage';
import Users from './pages/Users';
import Expenses from './pages/Expenses';
import ActivityLogs from './pages/ActivityLogs';
import Profile from './pages/Profile';
import RecentlyDeleted from './pages/RecentlyDeleted';
import Layout from './components/Layout';
import InstallPwaPrompt from './components/InstallPwaPrompt';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-amber-500 border-t-transparent"></div>
      </div>
    );
  }
  return user ? <Layout>{children}</Layout> : <Navigate to="/login" />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/inventory" element={<ProtectedRoute><GreenInventory /></ProtectedRoute>} />
            <Route path="/roasting" element={<ProtectedRoute><Roasting /></ProtectedRoute>} />
            <Route path="/roasted-stock" element={<ProtectedRoute><RoastedStockV2 /></ProtectedRoute>} />
            <Route path="/wastage" element={<ProtectedRoute><Wastage /></ProtectedRoute>} />
            <Route path="/users" element={<ProtectedRoute><Users /></ProtectedRoute>} />
            <Route path="/activity-logs" element={<ProtectedRoute><ActivityLogs /></ProtectedRoute>} />
            <Route path="/expenses" element={<ProtectedRoute><Expenses /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="/recently-deleted" element={<ProtectedRoute><RecentlyDeleted /></ProtectedRoute>} />
            <Route path="/" element={<Navigate to="/dashboard" />} />
            <Route path="*" element={<Navigate to="/dashboard" />} />
          </Routes>
          <InstallPwaPrompt />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
